var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16Z",
    fill: "#474A57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.62 10.934C11.598 9.95 10.834 9.2 9.594 9.2c-1.24 0-2.051.75-2.051 1.734 0 .964.786 1.735 2.004 1.735h.023c1.264 0 2.052-.771 2.052-1.735ZM11.382 14.04H7.756v10.04h3.626V14.04ZM20.284 13.804c2.386 0 4.174 1.435 4.174 4.52v5.756h-3.625V18.71c0-1.35-.525-2.27-1.838-2.27-1.002 0-1.598.62-1.86 1.22-.096.215-.12.514-.12.814v5.608H13.39s.048-9.099 0-10.04h3.626v1.421c.482-.683 1.343-1.658 3.269-1.658Z",
    fill: "#fff"
  })));
};
export default SvgLinkedin;